module.exports = __webpack_public_path__ + "img/IMG_1449.20b7e462.jpeg";